import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=0a529086"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a529086')) {
      api.createRecord('0a529086', component.options)
    } else {
      api.reload('0a529086', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=0a529086", function () {
      api.rerender('0a529086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/AppFooter.vue"
export default component.exports